<div class="reservation-list p-4">
  <div class="flex justify-between items-center mb-6">
    <div>
      <h1 class="text-3xl font-bold text-gray-900 mb-2">My Reservations</h1>
      <p class="text-gray-600">Manage and track your customer reservations</p>
    </div>
    <p-button appGlobalLoadingDisable 
      label="Add Reservation" 
      icon="pi pi-plus" 
      (onClick)="onAddReservation()">
    </p-button>
  </div>

  <p-card>
    <ng-template pTemplate="header">
      <div class="p-4">
        <div class="flex flex-wrap gap-4 items-center">
          <div class="flex items-center gap-2">
            <label class="text-sm font-medium text-gray-700">Search:</label>
            <input 
              type="text" 
              pInputText 
              [(ngModel)]="searchTerm" 
              placeholder="Search reservations..." i18n-placeholder
              class="w-64">
          </div>
          <div class="flex items-center gap-2">
            <label class="text-sm font-medium text-gray-700">Status:</label>
            <p-select 
              [(ngModel)]="statusFilter" 
              [options]="statusOptions" 
              optionLabel="label" 
              optionValue="value"
              placeholder="Filter by status" i18n-placeholder
              [style]="{'min-width': '150px'}">
            </p-select>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="overflow-x-auto">
      <p-table 
        [value]="reservations" 
        [loading]="loading"
        [tableStyle]="{'min-width': '60rem'}"
        [paginator]="true"
        [rows]="20"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} reservations">
        
        <ng-template pTemplate="header">
          <tr>
            <th>Customer</th>
            <th>Status</th>
            <th>Created Date</th>
            <th>Expiry Date</th>
            <th>Products</th>
            <th>Value</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="body" let-reservation>
          <tr>
            <td>
              <div class="flex items-center gap-2">
                <i class="pi pi-building text-gray-500"></i>
                <div>
                  <div class="font-medium">{{ reservation.customerName }}</div>
                  <div class="text-sm text-gray-500">{{ reservation.customerLocation }}</div>
                  @if (reservation.refNo) {
                  <div class="text-xs text-gray-400 mt-1">{{ reservation.refNo }}</div>
                  }
                </div>
              </div>
            </td>
            <td>
              <p-tag 
                [value]="reservation.status" 
                [severity]="getStatusSeverity(reservation.status)">
              </p-tag>
            </td>
            <td>
              <span class="text-sm">{{ formatDate(reservation.createdAt) }}</span>
            </td>
            <td>
              <span class="text-sm" [class]="reservation.isExpiringSoon ? 'text-red-600 font-medium' : ''">
                {{ formatDate(reservation.expiryDate) }}
              </span>
            </td>
            <td>
              <span class="text-sm">{{ reservation.productCount }} items</span>
            </td>
            <td>
              <span class="text-sm font-medium">{{ reservation.estimatedValue | number:'1.2-2':'de-DE' }} €</span>
            </td>
            <td>
              <div class="flex gap-2">
                <p-button appGlobalLoadingDisable 
                  label="View" 
                  [text]="true" 
                  size="small"
                  (onClick)="onViewReservation(reservation._id)">
                </p-button>
                <p-button 
                  label="Schedule" 
                  [text]="true" 
                  size="small"
                  (onClick)="onScheduleInteraction(reservation._id)"
                  [disabled]="reservation.status === 'CONVERTED' || reservation.status === 'EXPIRED'">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center py-8">
              <div class="flex flex-col items-center gap-4">
                <i class="pi pi-calendar text-gray-400 text-6xl"></i>
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-2">No reservations found</h3>
                  <p class="text-gray-600">Start by creating your first reservation</p>
                </div>
                <p-button appGlobalLoadingDisable 
                  label="Add Reservation" 
                  icon="pi pi-plus" 
                  (onClick)="onAddReservation()">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-card>
</div>




